import { refreshAbilities } from '@/composables/useAbilities'
import { useUserStore } from '@/stores/userStore'
import { buildHeaders } from '@/utils/helpers/actions'
import { getDeviceFingerprint } from '@/utils/helpers/deviceFingerprint'
import { createWrappedFetch } from '@/utils/helpers/fetchWithRefresh'

export const useApiModified = async (
  urlAndOptions: [ComputedRef<string>, RequestInit?],
  ability?: any,
  options?: { preserveErrorDetails?: boolean },
) => {
  const userStore = useUserStore()
  const fingerprint = await getDeviceFingerprint()

  const headers = buildHeaders(userStore.getRegional(), fingerprint)

  if (urlAndOptions[1]?.body instanceof FormData)
    delete headers['Content-Type']

  const wrappedFetch = createWrappedFetch({
    baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
    getHeaders: () => headers,
    preserveErrorDetails: options?.preserveErrorDetails,
  })

  const [url, requestInit] = urlAndOptions

  // executa a primeira chamada
  const fetchResult = await wrappedFetch(url.value, requestInit)

  if (ability) {
    const store = useUserStore()
    if (!store.userData) {
      const { loadAuthSession } = await import('@/composables/useAuthSession')

      await loadAuthSession()
    }
    const rules = await refreshAbilities()

    ability.update(rules)
  }

  return {
    data: fetchResult.data,
    response: fetchResult.response,
    error: fetchResult.error,
    execute: async () => {
      const result = await wrappedFetch(url.value, requestInit)

      fetchResult.data.value = result.data.value
      fetchResult.error.value = result.error.value
      fetchResult.response.value = result.response.value

      return result
    },
  }
}
